module.exports = __webpack_public_path__ + "static/media/s_sf_2.885eabd3.png";